import MonthlySubmissionConfirmationLayout from './MonthlySubmissionConfirmationLayout';

export default MonthlySubmissionConfirmationLayout;